import { I18nKeys, typedI18nFactory } from 'utils/typedI18nFactory';

import { en } from './en';
import { ru } from './ru';

export const i18n = typedI18nFactory({ ru, en });
export type PersonalDataKeys = I18nKeys<typeof i18n>;
